import React from 'react'
import { Button, ShareIcon } from '@farewill/ui'

import { COLOR, FONT, GTR } from '@farewill/ui/tokens'
import styled from 'styled-components'

const StyledDt = styled('dt')`
  font-size: ${FONT.SIZE.XS};
  font-weight: ${FONT.WEIGHT.BOLD};
  line-height: 1.5;
  text-transform: uppercase;
  color: ${COLOR.BLACK};
`

const StyledDd = styled('dd')`
  font-size: ${FONT.SIZE.M};
  line-height: 1.5;
  color: ${COLOR.GREY.DARK};
  margin: 0;
`

const StyledDiv = styled('div')`
  margin-bottom: ${GTR.M};
`

const RoleSidebar = ({
  location,
  salary,
  contractType,
  closingDate,
  roleUrl,
}: {
  location: string
  contractType: string
  salary: string
  closingDate: string
  roleUrl: string
}): React.JSX.Element => (
  <>
    <dl>
      <StyledDiv>
        <StyledDt>Location:</StyledDt>
        <StyledDd>{location}</StyledDd>
      </StyledDiv>
      <StyledDiv>
        <StyledDt>Contract:</StyledDt>
        <StyledDd>{contractType}</StyledDd>
      </StyledDiv>
      <StyledDiv>
        <StyledDt>Salary:</StyledDt>
        <StyledDd>{salary}</StyledDd>
      </StyledDiv>
      <StyledDiv>
        <StyledDt>Closing Date:</StyledDt>
        <StyledDd>{closingDate}</StyledDd>
      </StyledDiv>
    </dl>
    <Button.Primary href={roleUrl} target="_blank" rel="noopener noreferrer">
      <ShareIcon width={24} />
      &nbsp;Apply via Dignity
    </Button.Primary>
  </>
)

export default RoleSidebar
